$(function () {
  if ($("#js-slide").length) {

    function initSlick() {
      var slide = $("#js-slide");
      var imageNum = 0;
      slide
        .on("init", function (event, slick) {

          var dotsWrap = $("#js-slickDots");
          for (let i = 0; i < slick.slideCount; i++) {
            dotsWrap.append("<li class='p-slide__dot'></li>");
          }
          $("#js-slickDots li").eq(slick.currentSlide).addClass("current");
        })
        .slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          autoplay: false,
          autoplaySpeed: 5000,
        })
        .on("afterChange", function (event, slick) {

          if (imageNum === 0) {
            imageNum = document.querySelectorAll('.js-observeChange').length;
          } else if (imageNum !== document.querySelectorAll('.js-observeChange').length) {
            slick.unslick();
            return;
          }
          $("#js-slickDots li").removeClass("current");
          $("#js-slickDots li").eq(slick.currentSlide).addClass("current");
        });
      $("#js-prevSlide").on("click", function () {
        slide.slick("slickPrev");
      });
      $("#js-nextSlide").on("click", function () {
        slide.slick("slickNext");
      });
      $(document).on("click", "#js-slickDots li", function () {
        slide.slick("slickGoTo", $(this).index());
      });
    }
    initSlick();
    document.addEventListener('shopify:section:load', function (event) {
      initSlick();
      $("#js-slide").slick('slickPlay');
    });
  }
});

$(function () {

  $(".js-openAccordion").hover(
    function () {
      $(this).find(".js-accordion").removeClass("initial");
      $(this).find(".js-accordion").addClass("visible");
      $(this).find(".js-accordion").removeClass("hidden");
      $("body").addClass("overlay");
    },
    function () {
      $(this).find(".js-accordion").removeClass("visible");
      $(this).find(".js-accordion").addClass("hidden");
      $("body").removeClass("overlay");
    }
  );
});

// 現在選択されている言語によって日付の形式を変える
$(function () {
  $date = $(".js-changeDateFormat");
  if ($date.length) {
    $date.each(function (i, element) {
      const initialDate = $(element).data("date");
      const year = initialDate.slice(0, 4);
      const numMonth = initialDate.slice(5, 7);
      const day = initialDate.slice(8, 10);

      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const month = months[numMonth - 1];

      $(element).text(`${month} ${day}, ${year}`);
    });
  }
});

// 読み込み時アニメーション
function isTopPage() {
  return $("#js-animation").length === 0 ? false : true;
}
$(function () {
  if (!isTopPage()) return;
  const prevRef = document.referrer;
  if (
    prevRef.match(
      /^https*:\/\/(test-cherry-fukuoka|cherryfukuoka|cherry-fukuoka)/
    ) || window.performance.navigation.type === 2) {
    $("#js-animation").css({
      "opacity": "0",
      "transition": "0.4s",
      "animation": "none"
    });
    setTimeout(function () {
      $("#js-animation").css("display", "none");
      $("#js-slide").slick('slickPlay');
    }, 400);
  }
  // windowのonLoadで走らせるアニメーションの終了を検知する
  $("#js-showLogo").on("animationend", function (event) {
    event.stopPropagation();
    setTimeout(function () {
      $("#js-animation").addClass("showBelt");
    }, 500);
  });
  $("#js-showBelt").on("animationend", function (event) {
    event.stopPropagation();
    setTimeout(function () {
      $("#js-animation").addClass("showGlobe");
    }, 100);
  });
  $("#js-showGlobe").on("animationend", function (event) {
    event.stopPropagation();
    setTimeout(function () {
      $("#js-animation").addClass("hiddenLogo");
    }, 1000);
  });
  $("#js-animation").on("animationend", function () {
    $("#js-slide").slick('slickPlay');
  });
});
// windowのonLoadでアニメーションを走らせる
$(window).on("load", function () {
  if (isTopPage()) {
    $("#js-animation").addClass("showLogo");
  }
});

// ページトップに戻るボタン
$("#js-smoothScroll").on("click", function (event) {
  event.preventDefault();
  $("html").animate({
    scrollTop: 0
  }, Math.round($(this).offset().top / 8));
});

// メーリス登録時にスクロール
$(function () {
  const path = location.pathname + location.hash;
  if (path.match('challenge#ContactFooter')) {
    window.location.href = location.href.replace(location.hash, "");
  }
});

$(document).on('click', '.inquiry-btn-set', function () {
  $('.main-inquiry-section').addClass('open-modal');
  $('body').addClass('open-modal');
});
$(document).on('click', '.close-modal-popup', function () {
  $('.main-inquiry-section').removeClass('open-modal');
  $('body').removeClass('open-modal');
});
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();

    document.querySelector(this.getAttribute('href')).scrollIntoView({
      behavior: 'smooth'
    });
  });
});

// ヘッダーの文言の切り替え
$(function () {
  function changeHeight() {
    let maxHeight = 0;
    $(".js-header-flash").each(function (index, element) {
      maxHeight = maxHeight < $(element).outerHeight()
        ? $(element).outerHeight() : maxHeight;
    });
    $("#js-header-flash-wrapper").height(maxHeight);
  }
  function changeText() {
    let next = 0;
    $(".js-header-flash").each(function (index, element) {
      if ($(element).hasClass("current")) {
        next = $(".js-header-flash").length !== index + 1 ? index + 1 : 0;
      }
    });
    $(".js-header-flash").removeClass("current");
    $(".js-header-flash").eq(next).addClass("current");
    changeHeight();
  }
  changeHeight();
  window.setInterval(changeText, 3000);
});
